


























































































































































































































































































































































































































































import OrderExpressAndConsignee from '@/views/order/components/order_express_and_consignee.vue'
import {
  apiGroupBuyingOrderWriteOffDetail,
  apiOrderWriteOffOrderDetail,
  ApiOrderWriteOffOrderDetailResponse,
} from '@/api'
import { BookComponents } from '../components'
import { BookOrderComponents } from './components'
import { computed, ref } from '@vue/composition-api'
import {
  contactCustomerService,
  requiredDeep,
  showPicker,
  Track,
} from '@/utils'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { JointComponents } from '../../joint/components'
import { navigateTo } from '@/router'
import { wait } from 'vtils'

import GroupBuyingOrderActions from '@/views/group_buying/order/components/order_actions.vue'
import GroupBuyingOrderSchedule from '@/views/group_buying/order/components/order_schedule.vue'
import { GroupBuyingComponents } from '@/views/group_buying/components'

export default defineClassComponent(
  {
    components: {
      ...BookComponents,
      ...BookOrderComponents,
      ...JointComponents,
      OrderExpressAndConsignee,
      ...GroupBuyingComponents,
      GroupBuyingOrderSchedule,
      GroupBuyingOrderActions,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '订单详情',
        }))
      }

      query = useQuery<{
        orderNo: string
        fromParent: boolean
        isGroupBuying?: boolean
      }>()

      apiData = useApi(
        () =>
          (this.query.isGroupBuying
            ? (apiGroupBuyingOrderWriteOffDetail({
                orderId: this.query.orderNo,
              }) as Promise<ApiOrderWriteOffOrderDetailResponse>)
            : apiOrderWriteOffOrderDetail({
                orderNo: this.query.orderNo,
              })
          )
            .then(requiredDeep)
            .then(res => {
              const groupedSaleId: string[] = []
              res.codeList.forEach(code => {
                if (!code.saleId) {
                  // @ts-ignore
                  code.codes = [code.code]
                } else if (!groupedSaleId.includes(code.saleId)) {
                  groupedSaleId.push(code.saleId)
                  // @ts-ignore
                  code.codes = res.codeList
                    .filter(item => item.saleId === code.saleId)
                    .map(item => item.code)
                }
              })
              // @ts-ignore
              res.groupedCodeList = res.codeList.filter(
                code =>
                  // @ts-ignore
                  !!code.codes,
              )
              return res
            }),
        {
          refreshOnActivated: true,
        },
      )

      pageData = computed(() => this.apiData.data)

      is待支付 = computed(() => this.pageData.value.status === 0)

      isJoint = computed(() => this.pageData.value.orderClassify === 5)

      isTravel = computed(() => this.pageData.value.orderClassify === 6)

      qrcodeIndex = ref(0)

      isCodeListFold = ref(true)

      handleBannerChange = (index: number) => {
        this.qrcodeIndex.value = index
      }

      handleSubOrderClick = (orderNo: string) => {
        navigateTo('BookOrderDetail', {
          orderNo,
          fromParent: true,
        })
      }

      handleGoodsClick = () => {
        navigateTo(
          this.isTravel.value
            ? 'TravelGoodsIndex'
            : this.isJoint.value
            ? 'JointGoodsIndex'
            : 'BookGoodsIndex',
          {
            goodsId: this.pageData.value.commodityId,
          },
        )
      }

      handleRefresh = async () => {
        await wait(1500)
        this.apiData.refresh()
      }

      handleRefundClick = () => {
        navigateTo('BookRefundRequest', {
          orderNo: this.query.orderNo,
        })
      }

      handleRefundResultClick = (refundId: string) => {
        navigateTo('BookRefundResult', {
          refundId: refundId,
        })
      }

      handleInvoiceClick = () => {
        if (this.pageData.value.invoiceStatus === -1) {
          dcb.makePhoneCall({
            phoneNumber: '4009008799',
          })
        } else if (this.isJoint.value) {
          showPicker({
            title: '请选择开票订单',
            data: this.pageData.value.comboData[0].groupDetails.map(
              (item, index) => ({
                label: item.serviceName,
                value: index,
              }),
            ),
            initialValue: 0,
            onConfirm: index => {
              navigateTo(
                (this.pageData.value.comboData[0].groupDetails[index] as any)
                  .invoiceStatus === 2
                  ? 'InvoiceDetail'
                  : 'InvoiceRequest',
                {
                  orderNo: (
                    this.pageData.value.comboData[0].groupDetails[
                      index
                    ] as any
                  ).orderNo,
                },
              )
            },
          })
        } else {
          navigateTo(
            this.pageData.value.invoiceStatus === 2
              ? 'InvoiceDetail'
              : 'InvoiceRequest',
            {
              orderNo: this.pageData.value.orderNo,
            },
          )
        }
      }

      contactService = () => {
        contactCustomerService()
        // makeContactCustomerService({
        //   imMessageUrl: this.pageData.value.imMessage,
        // })
      }
    },
)
